import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Smartphone, CheckCircle, ArrowRight } from 'lucide-react';

const MobileApps = () => {
  const features = [
    'iOS and Android native apps',
    'Offline mode capabilities',
    'Real-time data synchronization',
    'Barcode and QR code scanning',
    'Photo capture and documentation',
    'GPS location tracking',
    'Push notifications',
    'User-friendly interface',
    'Secure authentication',
    'Cloud integration'
  ];

  return (
    <div className="min-h-screen bg-slate-50">
      <section className="bg-gradient-to-br from-slate-900 to-slate-800 text-white py-16 px-4">
        <div className="container mx-auto max-w-7xl">
          <div className="flex items-center justify-center mb-6">
            <Smartphone className="w-16 h-16 text-blue-400" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center">Mobile Applications</h1>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto text-center">
            Custom mobile solutions for on-the-go supply chain management
          </p>
        </div>
      </section>

      <section className="py-16 px-4">
        <div className="container mx-auto max-w-7xl">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">Empower Your Workforce with Mobile Technology</h2>
            <p className="text-lg text-slate-600">
              Our custom mobile applications bring the power of your supply chain management system to your employees' fingertips. Work efficiently from anywhere with intuitive, feature-rich mobile apps designed for warehouse and field operations.
            </p>
          </div>

          <div className="mb-16">
            <h3 className="text-2xl font-bold text-slate-900 mb-8 text-center">Key Features</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start space-x-3 bg-white p-4 rounded-lg shadow-sm">
                  <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                  <span className="text-slate-700">{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 bg-gradient-to-br from-blue-600 to-cyan-600 text-white">
        <div className="container mx-auto max-w-4xl text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Go Mobile with Your Operations</h2>
          <p className="text-xl mb-8 text-blue-100">
            Contact us to discuss your mobile app requirements
          </p>
          <Link to="/contact">
            <Button size="lg" className="bg-white text-blue-600 hover:bg-slate-100 px-8 py-6 text-lg transition-all duration-300 hover:scale-105">
              Get Started <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default MobileApps;